import React from 'react';
import App from './app/app';
import { createRoot } from 'react-dom/client';
import { initStore } from '@monorepo/controlled/src/hooks/use-stores';
import { IMFPStore, MFPStore } from './modules/stores';
// import reportWebVitals from './lib/tools/report-web-vitals';

const container: HTMLElement | null = document.getElementById('root');
const root = createRoot(container as Element);
initStore<IMFPStore>(MFPStore);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
